import { render } from "./SFGroupingsView.vue?vue&type=template&id=6ac256d6"
import script from "./SFGroupingsView.vue?vue&type=script&lang=js"
export * from "./SFGroupingsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__